import { useMemo } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { createThemeByMode } from "@rusha/shared-theme";
import "./styles/global.css";

import Navbar from "./components/layout/Navbar";
import HomePage from "./pages/HomePage";
import TemplateIndexPage from "./pages/templates/TemplateIndexPage";
import TemplateDetailPage from "./pages/templates/TemplateDetailPage";
import Footer from "./components/layout/Footer";
import { useThemeManager } from "./hooks/useThemeManager";
import DocsPage from "./pages/docs/DocsPage";

// Theme wrapper component that provides dynamic theme based on mode
function ThemeWrapper({ children }: { children: React.ReactNode }) {
  const { mode } = useThemeManager();

  const currentTheme = useMemo(() => {
    // Use createThemeByMode for proper dark/light palette
    return createThemeByMode(mode);
  }, [mode]);

  return (
    <ThemeProvider theme={currentTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}

function App() {
  return (
    <ThemeWrapper>
      <Router>
        <a href="#main" className="skip-link">
          Skip to content
        </a>
        <Navbar />
        <main id="main">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/templates" element={<TemplateIndexPage />} />
            <Route path="/templates/:slug" element={<TemplateDetailPage />} />
            <Route path="/docs" element={<DocsPage />} />
          </Routes>
        </main>
        <Footer />
      </Router>
    </ThemeWrapper>
  );
}

export default App;
